import { EditIcon } from '@chakra-ui/icons';
import { CloseIcon } from '@mybridge/icons';
import { Box, Button, HStack, Stack, Text } from '@mybridge/ui';
import { forwardRef, useContext, useEffect } from 'react';
import { MyTestimonialsContext } from '../context';
import { GivenNoDataIll } from '../ill/given-no-data';
import { GivenPendingNoDataIll } from '../ill/given-pending-no-data';
import { MyTestimonialsUserCard } from '../user-card';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

export const MyTestimonialsGivenListing = forwardRef(({ ...props }, ref) => {
  const {
    givenTestimonials,
    givenTestimonialsQuery,
    givenTestimonialsPendingRequests,
    givenTestimonialsPendingRequestsQuery,
    tab,
    selected,
    setSelected,
    giveTestimonialDisc,
    deleteTestimonialMutation,
    deleteTestimonial,
  } = useContext(MyTestimonialsContext);
  const { t } = useTranslator();
  useEffect(() => {
    if (tab === 1) {
      givenTestimonialsQuery?.refetch?.();
      givenTestimonialsPendingRequestsQuery?.refetch?.();
    }
  }, [tab]);
  return (
    <Stack spacing={4}>
      <Stack p={4} borderRadius={5} border="1px solid" borderColor="gray.200">
        {givenTestimonialsPendingRequests?.length ? (
          <>
            <Box display="flex" alignItems="center">
              <Text display="inline">{t('profileTestimonials.pendingRequests') || "Pending Requests"}</Text>
              <Text
                py={0.5}
                px={2}
                // size="sm"
                color="white"
                ml={1}
                bgColor="red.500"
                borderRadius="full"
                // display="inline"
                height="20px"
                width="20px"
                display="flex"
                alignItems="center"
                justifyContent="center"
                fontSize="xs"
              >
                {givenTestimonialsPendingRequests?.length}
              </Text>
            </Box>
            {givenTestimonialsPendingRequests?.map?.((tst, tIndex) => (
              <Stack
                {...(tIndex < givenTestimonialsPendingRequests?.length - 1
                  ? { borderBottom: '1px solid', borderColor: 'gray.200' }
                  : {})}
                p={4}
                key={tIndex}
                _hover={{
                  background: '#E2E2E2',
                }}
              >
                <MyTestimonialsUserCard
                  actions={
                    <HStack justifyContent="flex-end">
                      <Button
                        color="brandPrimary.500"
                        variant="ghost"
                        contSize
                        leftIcon={
                          <CloseIcon width={'20'} height={'20'} color="red" />
                        }
                        onClick={(e) => deleteTestimonial?.(tst)}
                        isLoading={
                          selected?.id === tst?.id &&
                          deleteTestimonialMutation?.isLoading
                        }
                      >
                        {t('profileNetwork.ignore') || "Ignore"}
                      </Button>
                      <Button
                        color="brandPrimary.500"
                        variant="ghost"
                        contSize
                        leftIcon={<EditIcon />}
                        onClick={(e) => {
                          setSelected(tst);
                          giveTestimonialDisc?.onOpen?.();
                        }}
                      >
                        {t('profileTestimonials.writeTestimonial') || "Write a testimonial"}
                      </Button>
                    </HStack>
                  }
                  user={tst?.asker}
                  message={tst?.message}
                  createdAt={tst?.created_at}
                ></MyTestimonialsUserCard>
              </Stack>
            ))}
          </>
        ) : (
          <Stack>
            <Text display="inline">{t('profileTestimonials.pendingRequests') || "Pending Requests"}</Text>
            <HStack justifyContent="center">
              <Stack alignItems="center">
                <GivenPendingNoDataIll />
                <Text display="inline">{t('profileTestimonials.noPendingRequests') || "No pending request at this time."}</Text>
              </Stack>
            </HStack>
          </Stack>
        )}
      </Stack>
      <Stack p={4} borderRadius={5} border="1px solid" borderColor="gray.200">
        {givenTestimonials?.length ? (
          <>
            <Text>{t('profileTestimonials.manageGivenTestimonials') || "Manage testimonials you've given"}</Text>
            {givenTestimonials?.map?.((testimonial, tIndex) => (
              <Stack
                {...(tIndex < givenTestimonials?.length - 1
                  ? { borderBottom: '1px solid', borderColor: 'gray.200' }
                  : {})}
                p={4}
                key={tIndex}
                _hover={{
                  background: '#E2E2E2',
                }}
              >
                <MyTestimonialsUserCard
                  actions={
                    <Button
                      color="brandPrimary.500"
                      variant="ghost"
                      leftIcon={<EditIcon />}
                      onClick={(e) => {
                        setSelected(testimonial);
                        giveTestimonialDisc?.onOpen?.();
                      }}
                    >
                      {t('buttons.edit') || "Edit"}
                    </Button>
                  }
                  user={testimonial?.asker}
                  message={testimonial?.testimonial}
                  createdAt={testimonial?.created_at}
                />
              </Stack>
            ))}
          </>
        ) : (
          <Stack>
            <Text display="inline">{t('profileTestimonials.manageGivenTestimonials') || "Manage testimonials you've given"}</Text>
            <HStack justifyContent="center">
              <Stack alignItems="center">
                <GivenNoDataIll />
                <Text display="inline">
                  {t('profileTestimonials.noTestimonialsToManage') || "You don't have any testimonial to manage"}
                </Text>
              </Stack>
            </HStack>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
});
